import MuiDialog, { DialogProps } from '@material-ui/core/Dialog'
import MuiDialogActions from '@material-ui/core/DialogActions'
import MuiDialogContent from '@material-ui/core/DialogContent'
import MuiDialogTitle from '@material-ui/core/DialogTitle'
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles'
import * as React from 'react'

import Color from '../base/Color'
import Typography from '../base/Typography'
import Button, { StyledButton } from '../button/Button'
import { IconList } from '../icons/Icons'
import ServiceTypeCard from '../molecules/ServiceTypeCard'

export type ChooseServiceModalProps = {
  title?: string
  cancelLabel?: string
  confirmLabel?: string
  btnVariantConfirm?: StyledButton
  btnVariantCancel?: StyledButton
  onCancel(): void
  onConfirm(): void
  data?: {
    iconName: keyof typeof IconList
    label: string
  }[]
} & DialogProps

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      background: Color.base.modalOverlay
    },
    paper: {
      padding: theme.spacing(5),
      position: 'relative',
      maxWidth: '100%'
    },
    title: {
      padding: 0,
      marginBottom: theme.spacing(3),
      textAlign: 'center'
    },
    content: {
      paddingTop: theme.spacing(1),
      marginBottom: theme.spacing(4),
      display: 'grid',
      gridGap: theme.spacing(2),
      gridAutoFlow: 'column'
    },
    action: {
      display: 'grid',
      gridGap: theme.spacing(2),
      gridAutoFlow: 'column',
      justifyContent: 'center',
      padding: 0
    },
    actionBtn: {
      width: 125
    }
  })
)

const ChooseServiceModal: React.FC<ChooseServiceModalProps> = (props) => {
  const {
    children,
    title = 'Please choose the type of service',
    cancelLabel,
    confirmLabel,
    onCancel,
    onConfirm,
    btnVariantConfirm,
    btnVariantCancel,
    data = [{ iconName: 'HouseIcon', label: 'Home' }],
    ...rest
  } = props
  const classes = useStyles()
  const [selectedCard, setSelectedCard] = React.useState('')
  return (
    <div>
      {children}
      <MuiDialog
        classes={{ root: classes.root, paper: classes.paper }}
        onClose={(): void => onCancel()}
        scroll="body"
        {...rest}
      >
        <MuiDialogTitle disableTypography classes={{ root: classes.title }}>
          <Typography variant="h4">{title}</Typography>
        </MuiDialogTitle>
        <MuiDialogContent classes={{ root: classes.content }}>
          {data.map((item, index) => (
            <ServiceTypeCard
              key={index}
              isSelected={selectedCard === item.label}
              onClick={(): void => setSelectedCard(item.label)}
              iconName={item.iconName}
              label={item.label}
            />
          ))}
        </MuiDialogContent>
        <MuiDialogActions classes={{ root: classes.action }}>
          <Button
            onClick={(): void => onCancel()}
            variants={btnVariantCancel ? btnVariantCancel.variants : 'ghost'}
            customSize="medium"
            children={cancelLabel ? cancelLabel : 'No'}
            className={classes.actionBtn}
          />
          <Button
            onClick={(): void => onConfirm()}
            variant="contained"
            variants={
              btnVariantConfirm ? btnVariantConfirm.variants : 'primary'
            }
            disabled={!selectedCard}
            customSize="medium"
            children={confirmLabel ? confirmLabel : 'Yes'}
            size="medium"
            className={classes.actionBtn}
          />
        </MuiDialogActions>
      </MuiDialog>
    </div>
  )
}

export default ChooseServiceModal
